
import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop} from 'vue-property-decorator';
import {IRouteOrder} from '@/model/Route/routeInterfaces';
import {BetterDataTableHeader} from '@/model/betterVuetifyInterfaces';
import {orderStatusColor} from '@/helpers/orderStatusHelper';

/**
 * Orders that can be added to a route. `orders` already excludes the selected ones, so selecting an order moves
 * it out of this list and into the route stops. Desktop keeps the selectable table; phones and tablets get a
 * tap-to-add list, since a 7-column table stacked per row is unusable there.
 */
@Component({name: 'RouteAvailableOrders'})
export default class RouteAvailableOrders extends Vue {
  @Prop({required: true}) protected orders!: IRouteOrder[];
  @Prop({required: true}) protected value!: IRouteOrder[];

  protected search: string = '';

  protected get compact(): boolean {
    return this.$vuetify.breakpoint.smAndDown;
  }

  protected get headers(): BetterDataTableHeader[] {
    return [
      {text: 'ID', value: 'id', sortable: false},
      {text: this.$t('routes.create.customer') as string, value: 'user_name', sortable: false},
      {text: this.$t('routes.create.channel') as string, value: 'channel_name', sortable: false},
      {text: this.$t('routes.create.location') as string, value: 'location', sortable: false},
      {text: this.$t('routes.create.city') as string, value: 'city', sortable: false},
      {text: this.$t('routes.create.sp') as string, value: 'service_provider_name', sortable: false},
      {text: this.$t('common.status') as string, value: 'trans_status', sortable: false},
    ];
  }

  // Same matching as v-data-table's default search over the header columns.
  protected get searchedOrders(): IRouteOrder[] {
    const term = (this.search || '').trim().toLocaleLowerCase();
    if (!term) {
      return this.orders;
    }

    return this.orders.filter((order) => this.headers.some((header) => {
      const value = (order as any)[header.value];
      return value !== null && value !== undefined && typeof value !== 'boolean'
        && value.toString().toLocaleLowerCase().indexOf(term) !== -1;
    }));
  }

  protected orderStatusColor(status: string): string {
    return orderStatusColor(status);
  }

  protected rowClass(order: IRouteOrder): string {
    return order.is_route_warning_order ? 'route-order--warning' : '';
  }

  protected addOrders(orders: IRouteOrder[]) {
    const selectedIds = this.value.map((order) => order.id);
    const added = orders.filter((order) => selectedIds.indexOf(order.id) === -1);
    if (added.length > 0) {
      this.$emit('input', this.value.concat(added));
    }
  }
}
